import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IOptionGroupPayload, IUpdateOptionGroupRequestBody } from './types';

export const updateModifierGroup = async (
  itemId: string,
  modifierGroupId: string,
  requestBody: Partial<IOptionGroupPayload | IUpdateOptionGroupRequestBody>,
  priceSchemeId: string,
): Promise<Response> => {
  const url = `${API_URL}/items/${itemId}/modifier-groups/${modifierGroupId}`;

  try {
    const res = await fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(requestBody),
      headers: {
        [PRICE_SCHEME_HEADER]: priceSchemeId,
      },
    });
    if (!res.ok) throw new Error(res.statusText);
    return res;
  } catch (e) {
    throw new Error('Could not update modifier group', { cause: e });
  }
};
